import { useState } from 'react';
import { Icon } from '../material';
import { PlacePicker } from './place-picker';

/**
 * The «Адрес» input of «Мои адреса» — the field that opens the town catalogue. A port
 * of `address_field.dart`.
 *
 * It reads as the input it stands in for and behaves as the route rows of «Новый
 * заказ» do: a tap opens the same sheet, over the same catalogue, with the same row
 * underneath for the words the passenger typed themselves. A saved place is still
 * free text — «Дом» is in no catalogue — but an address typed from memory is how one
 * street ends up saved under three spellings.
 *
 * A taken row fills the address and nothing else. «Название» is the passenger's own
 * word for the place, and the catalogue has no opinion worth putting there.
 */
export function AddressField({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder: string;
}) {
  const [picking, setPicking] = useState(false);
  const address = value.trim();

  return (
    <>
      <button type="button" className="address-field" onClick={() => setPicking(true)}>
        <Icon name="place_outlined" size={17} style={{ color: 'var(--faint)' }} />
        <span className={address ? 'grow ellipsis' : 'grow ellipsis empty'}>
          {address || placeholder}
        </span>
        <Icon name="chevron_right" size={18} style={{ color: 'var(--faint)' }} />
      </button>
      {picking && (
        <PlacePicker
          title="Адрес"
          initial={address}
          fills="address"
          onClose={() => setPicking(false)}
          onPick={(picked) => {
            onChange(picked);
            setPicking(false);
          }}
        />
      )}
    </>
  );
}
